import { render, staticRenderFns } from "./LabelValue.vue?vue&type=template&id=0cb368a0&scoped=true&"
import script from "./LabelValue.vue?vue&type=script&lang=js&"
export * from "./LabelValue.vue?vue&type=script&lang=js&"
import style0 from "./LabelValue.vue?vue&type=style&index=0&id=0cb368a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb368a0",
  null
  
)

export default component.exports